import actionTypes from '../actions/media-templates.actions';

const initialState = {
  entries: [],
  fonts: [],
  isLoading: false,
  isSaving: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MEDIA_TEMPLATE_REQUEST:
    case actionTypes.FETCH_MEDIA_TEMPLATE_FAILURE:
    case actionTypes.FETCH_FONTS_REQUEST:
    case actionTypes.FETCH_FONTS_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case actionTypes.FETCH_MEDIA_TEMPLATE_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        entries: [...action.entries],
      };
    case actionTypes.FETCH_FONTS_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        fonts: [...action.fonts],
      };
    case actionTypes.UPDATE_MEDIA_TEMPLATE_REQUEST:
      return {
        ...state,
        isSaving: action.isSaving,
      };
    case actionTypes.UPDATE_MEDIA_TEMPLATE_FAILURE:
    case actionTypes.UPDATE_MEDIA_TEMPLATE_SUCCESS:
      return {
        ...state,
        isSaving: action.isSaving,
        error: action.error,
      };
    case actionTypes.PREVIEW_MEDIA_TEMPLATE_REQUEST:
      return {
        ...state,
        isPreviewing: action.isPreviewing,
      };
    case actionTypes.PREVIEW_MEDIA_TEMPLATE_FAILURE:
    case actionTypes.PREVIEW_MEDIA_TEMPLATE_SUCCESS:
      return {
        ...state,
        isPreviewing: action.isPreviewing,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/media-templates.reducer.js